import { useEffect, useState } from 'react';
import StatusEnum from 'axios/enum';
import { MethodEnum } from 'axios/type';
import useAxios from 'axios/useAxios';
import { option2Trans } from 'tradevan-ui/consts';
import { Ioption } from 'tradevan-ui/type';

interface IuseQuerySupplierCodeListDetail extends Ioption {
  value: string;
  text: string;
}

interface IqueryBranchListResponse {
  contents: IuseQuerySupplierCodeListDetail[];
}

/** 分店/倉庫代碼 選單OpTrs */
const useBranchListOpTrs = (retailerId: string) => {
  const [option, setOption] = useState<IuseQuerySupplierCodeListDetail[]>([]);
  const axios = useAxios();
  useEffect(() => {
    if (retailerId) {
      (async () => {
        const response = await axios.doAxios<unknown, IqueryBranchListResponse>(
          MethodEnum.post,
          'common/queryBranchList',
          {
            retailerId,
          },
        );
        if (response && response.data.status === StatusEnum.完成) {
          setOption(
            response.data.data.contents.map((obj) => ({
              ...obj,
              value: obj.value,
              label: obj.text,
            })),
          );
        }
      })();
    }
  }, [retailerId]);
  return option2Trans(option);
};

export default useBranchListOpTrs;
